<svg class="icon-context" [class.active]="isActive" width="16" height="16" viewBox="0 0 16 16" fill="none"
     xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.5 1.5H3.5C2.94772 1.5 2.5 1.94772 2.5 2.5V13.5C2.5 14.0523 2.94771 14.5 3.5 14.5H12.5C13.0523 14.5 13.5 14.0523 13.5 13.5V5.5M9.5 1.5V4.5C9.5 5.05228 9.94772 5.5 10.5 5.5H13.5M9.5 1.5L13.5 5.5"
        stroke="var(--text-color-dark)"/>
    <path d="M5.5 9.5L7.5 11.5L11.5 7.5" stroke="var(--text-color-dark)"/>
</svg>
